import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "app__property--small" }, [
  /*#__PURE__*/_createElementVNode("b", null, "CONTACTELE MELE COLOR METAL")
], -1)
const _hoisted_2 = {
  class: "dashboard__div__content",
  style: {"flex-direction":"column"}
}
const _hoisted_3 = { style: {"font-size":"12px","color":"#90A4AE"} }
const _hoisted_4 = {
  href: "tel:contact.phoneNr",
  style: {"color":"red","text-decoration":"none"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = ["href"]

import {TColorMetalAgentAsContact} from '@/types/TColorMetalAgentAsContact';
import {ServiceUser} from "@/services/ServiceUser";
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableContacts = ref([]) as TColorMetalAgentAsContact[];

ServiceUser.getMyColorMetalUserContacts().then(result=>{
  // console.log('getMyColorMetalUserContacts.result=%o',result)
  if(result.status=='success'){
    //tableContacts.value=[...result.colorContacts];
    tableContacts.value=result.colorContacts;
    // console.log('tableContacts.value=%o',tableContacts.value)
  }else{
    // console.log('cum adica?!AAAAAAAAAAAAAAAAAAAAA');
  }
})



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableContacts), (contact) => {
        return (_openBlock(), _createElementBlock("div", {
          key: contact.email,
          class: "app__label--large"
        }, [
          _createVNode(_component_q_icon, {
            name: "perm_contact_calendar",
            style: {"font-size":"1rem","color":"#90A4AE"}
          }),
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(contact.lastName) + " " + _toDisplayString(contact.firstName) + " ", 1),
            _createElementVNode("a", _hoisted_4, _toDisplayString(contact.phoneNr), 1),
            _hoisted_5,
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createElementBlock("br", _hoisted_6))
              : _createCommentVNode("", true),
            _hoisted_7,
            _createElementVNode("a", {
              href: 'mailto:' + contact.email,
              style: {"text-decoration":"none"}
            }, _toDisplayString(contact.email), 9, _hoisted_8)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})